import { render, staticRenderFns } from "./DetailType6.vue?vue&type=template&id=2534e2f6&"
import script from "./DetailType6.vue?vue&type=script&lang=js&"
export * from "./DetailType6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports